export const CLASSIFICATION_CLASS_NAMES: Record<string, string> = {
  Target: "bg-green-100 text-green-700 border-green-400",
  High: "bg-yellow-100 text-yellow-700 border-yellow-400",
  Low: "bg-yellow-100 text-yellow-700 border-yellow-400",
  "Very High": "bg-red-100 text-red-700 border-red-400",
  "Very Low": "bg-red-100 text-red-700 border-red-400",
  "Critical High": "bg-fuchsia-100 text-fuchsia-700 border-fuchsia-400",
  "Critical Low": "bg-fuchsia-100 text-fuchsia-700 border-fuchsia-400",
};
